//common
import { Carousel } from './blocks/carousel';
import { Autoplay, Navigation, Pagination } from 'swiper';
import './common';

//components
// import './blocks/media'
// import './blocks/tab'
// import './blocks/slider-article'
// import './blocks/slider-laplandia-features'
// import './blocks/slider-laplandia-product'
// import './blocks/slider-product-recipes'

new class extends Carousel{
    getClasses() {
        return {
            ...super.getClasses(),
            carousel: '_laplandiapro-hero',
        }
    }

    getModules() {
        return [Pagination, Autoplay];
    }

    getSettings(item) {
        const settings = {
            ...super.getSettings(item),
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
        }
        return  settings;
    }
}

new class extends Carousel{
    getClasses() {
        return {
            ...super.getClasses(),
            carousel: '_laplandiapro-products',
        }
    }

    getModules() {
        return [Navigation, Autoplay];
    }

    getSettings(item) {
        let loop = item.querySelectorAll('.swiper-slide').length > 4;
        const settings = {
            ...super.getSettings(item),
            slidesPerView: 'auto',
            spaceBetween: 24,
            loop: true,
            breakpoints: {
                1200: {
                    spaceBetween: 40,
                    loop,
                }
            },
        }
        return  settings;
    }
}

new class extends Carousel{
    getClasses() {
        return {
            ...super.getClasses(),
            carousel: '_laplandiapro-articles',
        }
    }

    getModules() {
        return [Navigation];
    }

    getSettings(item) {
        const settings = {
            ...super.getSettings(item),
            slidesPerView: 'auto',
            spaceBetween: 16,
            loop: false,
            autoplay: false,
        }
        return  settings;
    }
}